<template>
  <div class="footer">
    <div class="footer-item" @click="go('/question/index')">
      <img :src="isMyActive ? questionImg : questionActiveImg" alt="" class="item-icon">
      <div class="item-text" :class="isMyActive ? '': 'item-text-active' ">问卷</div>
    </div>
    <div class="footer-item" @click="go('/my/index')">
      <img :src="isMyActive ? myActiveImg: myImg" alt="" class="item-icon">
      <div class="item-text" :class="isMyActive ? 'item-text-active': '' ">个人信息</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      questionImg: require('../assets/images/footer/question.png'), 
      questionActiveImg: require('../assets/images/footer/question_active.png'), 
      myImg: require('../assets/images/footer/my.png'), 
      myActiveImg: require('../assets/images/footer/my_active.png'), 
    }
  },
  methods: {
    go(path) {
      if (path === '/my/index') {
        if (this.isMyActive) {
          return
        }
      } else {
        if (!this.isMyActive) {
          return
        }
      }
      this.$router.replace(path)
    }
  },
  computed: {
    isMyActive: {
      get() {
        const flag = this.$route.meta.active
        return flag === 'my' ? true : false
      }
    }
  }
}
</script>

<style lang="stylus">
  .footer {
    z-index: 999;
    position:fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    height: 100px;
    width: 100%;
    padding: 10px 0;
    background: #fff;   
    box-shadow: 0px 5px 24px 0px rgba(0, 0, 0, 0.1);
    .footer-item {
      flex-basis: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 100%;
      color: #888888;
      font-size: 20px;
      .item-icon {
        width: 36px;
        height: 36px;
      }
      .item-text {
        margin-top: 10px
      }
      .item-text-active{
        color: #161828
      }
    }
  }
</style>